import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { connectLeftSideMenuDesktop } from "./LeftSideMenuDesktop.connect";
import SVG_GreyhoundIcon from "../../assets/images/svgs/greyhound.svg";
import SVG_HorseIcon from "../../assets/images/svgs/horse.svg?react";
// import SVG_TennisIcon from "../../assets/images/svgs/tennis.svg?react";
import SVG_FootballIcon from "../../assets/images/svgs/football.svg?react";
// import SVG_CricketIcon from "../../assets/images/svgs/cricket.svg?react";
// import Svg_SpadeIcon from "../../assets/images/svgs/spade-dark.svg?react";
// import SVG_SpadeIcon from "../../assets/images/svgs/spade.svg?react";
// import SVG_CardDeckIcon from "../../assets/images/svgs/cards-deck.svg?react";
// import SVG_RocketIcon from "../../assets/images/svgs/rocket.svg?react";
// import SVG_DiceIcon from "../../assets/images/svgs/dice.svg?react";
// import SVG_StarIcon from "../../assets/images/svgs/star.svg?react";
import SVG_HomeIcon from "../../assets/images/svgs/home.svg?react";
import SVG_CricketWhiteIcon from "../../assets/images/svgs/cricket_white.svg?react";
import SVG_TennisWhiteIcon from "../../assets/images/svgs/tennis_white.svg?react";
import SVG_PreviousIcon from "../../assets/images/svgs/previous.svg?react";
import SVG_RightIcon from "../../assets/images/svgs/right.svg?react";
// import SVG_ElectionIcon from "../../assets/images/svgs/election.svg?react";
import SVG_SportsBook from "../../assets/images/svgs/sportsBook.svg?react";
import { useSelector } from "react-redux";
import { getZonedTime, tsToDate } from "../../helpers/date.helper";
import { USER_DATA } from "../../config/app.config";
import { toastr } from "react-redux-toastr";
import {
  AuraSVG,
  AvitorSVG,
  CricketSVG,
  ElectionSVG,
  FootballSVG,
  GreySVG,
  HomeSVG,
  HorseSVG,
  LiveCasinoSVG,
  SlotSVG,
  TennisSVG,
} from "../SvgImage/SvgImage";

const LeftSideMenuDesktop = ({
  menu,
  homeMarketEvents,
  actions,
  timeSettings,
  auth,
  user,
  sportPageEvent,
  sportItemData,
  openSport,
  moreDetailed,
  eventDetailed,
  detailedGroupName,
  competition,
  navigationName,
  sportData,
  hrEventId,
  hrMarketId,
}) => {
  const onOpenDetailedMenu = () => {
    setDetailedSideBar(!detailedSideBar);
  };

  const navigate = useNavigate();
  const location = useLocation();
  const [detailedSideBar, setDetailedSideBar] = useState(false);
  const [oneDetailItem, setOneDetailItem] = useState();
  const [oneDetailName, setOneDetailName] = useState();
  const [displayNone, setDisplayNone] = useState(false);
  const isNavigationOpen = useSelector(
    (state) => state.navigationHeaderMenu.isOpen
  );

  let userDetail = localStorage.getItem(USER_DATA);
  let userData = JSON.parse(userDetail);

  useEffect(() => {
    if (isNavigationOpen) {
      setDetailedSideBar(true);
    }
  }, [isNavigationOpen]);

  useEffect(() => {
    if (
      sportData?.length &&
      sportData?.length > 0 &&
      !location.pathname.includes("event-page") &&
      (navigationName === "Greyhound Racing" ||
        navigationName === "Horse Racing")
    ) {
      const alreadyExists = sportData.find(
        (item) => item?.match_id === hrEventId && item?.market_id === hrMarketId
      );

      if (!alreadyExists) {
        actions.setHrEventId(sportData[0]?.match_id);
        actions.setHrMarketId(sportData[0]?.market_id);
        actions.setHrCountryCode(sportData[0]?.country_code);
      } else {
        actions.setHrCountryCode(alreadyExists?.country_code);
      }
    }
  }, [sportData, location, navigationName, hrEventId, hrMarketId]);

  const GetHomeMarketSuccess = async (...args) => {
    try {
      const result = args[0].map((innerArray) => {
        return innerArray.reduce((acc, item) => {
          const { competitionName } = item;
          const existingIndex = acc.findIndex(
            (obj) => obj.competitionName === competitionName
          );

          if (existingIndex === -1) {
            acc.push({
              competitionName,
              data: [item],
            });
          } else {
            acc[existingIndex].data.push(item);
          }

          return acc;
        }, []);
      });

      actions.getFreeHomeAllMarketsSuccess(result);
    } catch (error) {
      actions.getFreeHomeAllMarketsError();
    }
  };

  const onMoreDetails = () => {
    actions.setIsEventDetailed(!eventDetailed);
  };

  const FetchHomeAllEvents = async (eventTypeId, competitionId) => {
    const data = {
      eventTypeId,
      competitionId,
    };

    setTimeout(() => {
      actions.requestHomeAllEvents(data);
    }, 500);
  };

  function toTitleCase(str) {
    return str?.replace(
      /\w\S*/g,
      (text) => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
    );
  }

  useEffect(() => {
    if (location.pathname.includes("sports-page")) {
      const segmant = location.pathname.split("/");
      setOneDetailItem(segmant[3]);
      setOneDetailName(toTitleCase(segmant[2]));
    } else if (location.pathname.includes("competition-detail-page")) {
      const segmant = location.pathname.split("/");
      actions.setIsEventDetailed(true);
      if (!oneDetailName) {
        setOneDetailItem(segmant[3]);
        setOneDetailName(
          segmant[3] == "1"
            ? "Football"
            : segmant[3] == "2"
            ? "Tennis"
            : segmant[3] == "4"
            ? "Cricket"
            : ""
        );
      }
      actions.setIsDetailedGroupName(decodeURIComponent(segmant[2]));
      FetchHomeAllEvents(segmant[3], segmant[4]);
    } else if (location.pathname.includes("event-page")) {
      const segmant = location.pathname.split("/");
      setOneDetailItem(segmant[2]);
      setOneDetailName(
        segmant[2] == "1"
          ? "Football"
          : segmant[2] == "2"
          ? "Tennis"
          : segmant[2] == "4"
          ? "Cricket"
          : ""
      );
      actions.setIsNavigationName(
        segmant[2] == "1"
          ? "Football"
          : segmant[2] == "2"
          ? "Tennis"
          : segmant[2] == "4"
          ? "Cricket"
          : ""
      );
    } else if (
      location.pathname.includes("horse-racing") ||
      location.pathname.includes("greyhound-racing")
    ) {
      const segmant = location.pathname.split("/");
      setOneDetailItem(segmant[1]);
      setOneDetailName(
        segmant[1] == "horse-racing"
          ? "Horse Racing"
          : segmant[1] == "greyhound-racing"
          ? "Greyhound Racing"
          : ""
      );
      actions.setIsNavigationName(
        segmant[1] == "horse-racing"
          ? "Horse Racing"
          : segmant[1] == "greyhound-racing"
          ? "Greyhound Racing"
          : ""
      );
    } else {
      setOneDetailName(navigationName);
    }
  }, [location.pathname, navigationName]);

  const isSportAvailable = (id) => {
    return menu.some((sport) => sport.sport_id === id);
  };

  const getMenu = (data) => {
    actions
      .requestRacingPageData(data)
      .catch((e) => console.log("menu error = ", e));
  };

  const getTimeDifference = (dateTime) => {
    const targetDate = new Date(dateTime);
    const currentDate = new Date();

    const diffInMs = targetDate.getTime() - currentDate.getTime();
    const isPast = diffInMs < 0;
    const diffInSeconds = Math.abs(diffInMs) / 1000;

    const days = Math.floor(diffInSeconds / (3600 * 24));
    const hours = Math.floor((diffInSeconds % (3600 * 24)) / 3600);
    const minutes = Math.floor((diffInSeconds % 3600) / 60);

    if (isPast) {
      if (days > 0) return `Started on ${days} days ${hours} hours`;
      return `Started on ${hours} hours ${minutes} minutes`;
    } else {
      if (days > 0) return `Opens in ${days} days ${hours} hours`;
      return `Opens in ${hours} hours ${minutes} minutes`;
    }
  };

  const sideMainMenu =
    !location.pathname.includes("competition-detail-page") &&
    !location.pathname.includes("event-page") &&
    !location.pathname.includes("sports-page") &&
    !location.pathname.includes("horse-racing") &&
    !location.pathname.includes("greyhound-racing");

  return (
    <>
      <div
        title="Menu"
        id="leftDeskSideBar"
        className="hidden lg:flex p-2 overflow-y-auto z-10 w-[20%] h-[calc(100dvh-120px)] sticky top-[54px] lg:top-[110px]"
      >
        {sideMainMenu ? (
          <ul className="flex border  rounded-lg border-ternary3 bg-bg_Quaternary overflow-x-hidden flex-col w-full ">
            {isSportAvailable("4") && (
              <li className="border-border_color_primary opacity-70 hover:opacity-100 text-sm cursor-pointer py-4 text-nowrap  whitespace-nowrap autoAnimate font-semibold w-full border-b hover:bg-bg_MenuHoverColor hover:scale-[102%] ">
                <Link
                  className="flex w-full items-center h-full px-6 justify-start gap-3 text-white"
                  to={"/sports-page/Cricket/4"}
                  onClick={() => {
                    // setOneDetailItem('4')
                    // setOneDetailName('Cricket')
                    actions.setIsNavigationID("4");
                    actions.setIsNavigationName("Cricket");
                    onOpenDetailedMenu(!detailedSideBar);
                    actions.setRenderIonContent(false);
                    setDisplayNone(false);
                    actions.setIsEventDetailed(false);
                  }}
                >
                  {/* <SVG_CricketIcon width={20} height={20} /> */}
                  <CricketSVG height={20} width={20} />
                  <span className=" font-medium text-start text-text_Ternary ">
                    Cricket
                  </span>
                </Link>
              </li>
            )}
            {isSportAvailable("1") && (
              <li className="border-border_color_primary opacity-70 hover:opacity-100  text-sm cursor-pointer py-4 text-nowrap  whitespace-nowrap autoAnimate font-semibold w-full border-b hover:bg-bg_MenuHoverColor hover:scale-[102%] ">
                <Link
                  className="flex w-full items-center h-full px-6 justify-start text-white gap-3"
                  to={"/sports-page/football/1"}
                  onClick={() => {
                    // setOneDetailItem('1')
                    // setOneDetailName('Football')
                    actions.setIsNavigationID("1");
                    actions.setIsNavigationName("Football");
                    onOpenDetailedMenu(!detailedSideBar);
                    actions.setRenderIonContent(false);
                    setDisplayNone(false);
                    actions.setIsEventDetailed(false);
                  }}
                >
                  {/* <SVG_FootballIcon width={20} height={20} /> */}
                  <FootballSVG height={20} width={20} />
                  <span className=" font-medium text-start text-text_Ternary ">
                    Football
                  </span>
                </Link>
              </li>
            )}
            {isSportAvailable("2378961") && (
              <li className="border-border_color_primary opacity-70 hover:opacity-100  text-sm cursor-pointer py-4 text-nowrap  whitespace-nowrap autoAnimate font-semibold w-full border-b hover:bg-bg_MenuHoverColor hover:scale-[102%] ">
                <Link
                  className="flex w-full items-center h-full px-6 justify-start gap-3 text-white"
                  to={"/election"}
                  // onClick={() => {
                  //   actions.setIsNavigationID("2378961");
                  //   actions.setIsNavigationName("Election");
                  //   onOpenDetailedMenu(!detailedSideBar);
                  //   actions.setRenderIonContent(false);
                  //   setDisplayNone(false);
                  //   actions.setIsEventDetailed(false);
                  // }}
                >
                  {/* <SVG_ElectionIcon width={20} height={20} /> */}
                  <ElectionSVG height={20} width={20} />
                  <span className=" font-medium text-start text-text_Ternary ">
                    Election
                  </span>
                </Link>
              </li>
            )}
            {isSportAvailable("2") && (
              <li className="border-border_color_primary opacity-70 hover:opacity-100  text-sm cursor-pointer py-4 text-nowrap  whitespace-nowrap autoAnimate font-semibold w-full border-b hover:bg-bg_MenuHoverColor hover:scale-[102%] ">
                <Link
                  className="flex w-full items-center h-full px-6 justify-start gap-3 text-white"
                  to={"/sports-page/tennis/2"}
                  onClick={() => {
                    // setOneDetailItem('2')
                    // setOneDetailName('Tennis')
                    actions.setIsNavigationID("2");
                    actions.setIsNavigationName("Tennis");
                    onOpenDetailedMenu(!detailedSideBar);
                    actions.setRenderIonContent(false);
                    setDisplayNone(false);
                    actions.setIsEventDetailed(false);
                  }}
                >
                  {/* <SVG_TennisIcon width={20} height={20} /> */}
                  <TennisSVG height={20} width={20} />
                  <span className=" font-medium text-start text-text_Ternary ">
                    Tennis
                  </span>
                </Link>
              </li>
            )}
            {isSportAvailable("7") && (
              <li className="border-border_color_primary opacity-70 hover:opacity-100 text-sm cursor-pointer py-4 text-nowrap  whitespace-nowrap autoAnimate font-semibold w-full border-b hover:bg-bg_MenuHoverColor hover:scale-[102%] ">
                <Link
                  className="flex w-full items-center h-full px-6 justify-start gap-3 text-white"
                  to={"/horse-racing"}
                  onClick={() => {
                    const horseRacing = { sport_id: "7" };

                    setOneDetailName("Horse Racing");
                    getMenu(horseRacing);
                    actions.setIsNavigationID("7");
                    actions.setIsNavigationName("Horse Racing");
                    onOpenDetailedMenu(!detailedSideBar);
                    actions.setRenderIonContent(false);
                    setDisplayNone(false);
                    actions.setIsEventDetailed(false);
                  }}
                >
                  {/* <SVG_HorseIcon /> */}
                  <HorseSVG height={20} width={20} />
                  <span className=" font-medium text-start text-text_Ternary ">
                    Horse Racing
                  </span>
                </Link>
              </li>
            )}
            {isSportAvailable("4339") && (
              <li className="border-border_color_primary opacity-70 hover:opacity-100 text-sm cursor-pointer py-4 text-nowrap  whitespace-nowrap autoAnimate font-semibold w-full border-b hover:bg-bg_MenuHoverColor hover:scale-[102%] ">
                <Link
                  className="flex w-full items-center h-full px-6 justify-start gap-3 text-white"
                  to={"/greyhound-racing"}
                  onClick={() => {
                    const horseRacing = { sport_id: "4339" };

                    setOneDetailName("Greyhound Racing");
                    getMenu(horseRacing);
                    actions.setIsNavigationID("4339");
                    actions.setIsNavigationName("Greyhound Racing");
                    onOpenDetailedMenu(!detailedSideBar);
                    actions.setRenderIonContent(false);
                    setDisplayNone(false);
                    actions.setIsEventDetailed(false);
                  }}
                >
                  {/* <img src={SVG_GreyhoundIcon} /> */}
                  <GreySVG height={20} width={20} />
                  <span className=" font-medium text-start text-text_Ternary ">
                    Greyhound Racing
                  </span>
                </Link>
              </li>
            )}
            {isSportAvailable("QT") && (
              <li className="border-border_color_primary opacity-70 hover:opacity-100 text-sm cursor-pointer py-4 text-nowrap  whitespace-nowrap autoAnimate font-semibold w-full border-b hover:bg-bg_MenuHoverColor hover:scale-[102%] ">
                <Link
                  className="flex w-full items-center h-full px-6 justify-start gap-3 text-white"
                  to={userData?.is_demo ? "#" : "/livegames/aura/FAWK"}
                  onClick={() => {
                    if (userData?.is_demo) {
                      toastr.error("", "Please login from your read ID.");
                      return;
                    }
                  }}
                >
                  {/* <SVG_SpadeIcon
                    width={15}
                    height={15}
                    fill={"var(--color-secondary)"}
                  /> */}
                  <AuraSVG height={20} width={20} />
                  <span className=" font-medium text-start text-text_Ternary ">
                    Indian Card Games
                  </span>
                </Link>
              </li>
            )}

            <li className="border-border_color_primary opacity-70 hover:opacity-100 text-sm cursor-pointer py-4 text-nowrap  whitespace-nowrap autoAnimate font-semibold w-full border-b hover:bg-bg_MenuHoverColor hover:scale-[102%] ">
              <Link
                className="flex w-full items-center h-full px-6 justify-start gap-3 text-white"
                // to={"#"}
                to={"/sports-page/Sportsbook/0"}
                onClick={() => {
                  actions.setIsNavigationID("0");
                  actions.setIsNavigationName("Sportsbook");
                }}
              >
                <HomeSVG height={20} width={20} />
                <span className=" font-medium text-start text-text_Ternary ">
                  Sportsbook
                </span>
              </Link>
            </li>
            {isSportAvailable("QT") && (
              <>
                <li className="border-border_color_primary opacity-70 hover:opacity-100 text-sm cursor-pointer py-4 text-nowrap  whitespace-nowrap autoAnimate font-semibold w-full border-b hover:bg-bg_MenuHoverColor hover:scale-[102%] ">
                  <Link
                    className="flex w-full items-center h-full px-6 justify-start gap-3 text-white"
                    to={"#"}
                    onClick={(e) => {
                      e.preventDefault();
                      if (auth) {
                        if (userData?.is_demo) {
                          toastr.error("", "Please login from your read ID.");
                          return;
                        }
                        navigate("/casino-lobby/casino");
                        if (
                          !location.pathname.includes("/casino-lobby/casino")
                        ) {
                          actions.openSlotCasinoPopUp();
                        }
                      } else {
                        actions.setLoginNew(true);
                        actions.setLoginNavigationData({
                          page: "casino-lobby/casino",
                          ids: [],
                        });
                      }
                    }}
                  >
                    {/* <SVG_CardDeckIcon /> */}
                    <LiveCasinoSVG height={20} width={20} />
                    <span className=" font-medium text-start text-text_Ternary ">
                      Live Casino
                    </span>
                  </Link>
                </li>
                <li className="border-border_color_primary opacity-70 hover:opacity-100 text-sm cursor-pointer py-4 text-nowrap  whitespace-nowrap autoAnimate font-semibold w-full border-b hover:bg-bg_MenuHoverColor hover:scale-[102%] ">
                  <Link
                    className="flex w-full items-center h-full px-6 justify-start gap-3 text-white"
                    to={"#"}
                    onClick={(e) => {
                      e.preventDefault();
                      if (auth) {
                        if (userData?.is_demo) {
                          toastr.error("", "Please login from your read ID.");
                          return;
                        }
                        navigate("/casino-live/SPB-aviator/SPB");
                        if (
                          !location.pathname.includes(
                            "/casino-live/SPB-aviator/SPB"
                          )
                        ) {
                          actions.openSlotCasinoPopUp();
                        }
                      } else {
                        actions.setLoginNew(true);
                        actions.setLoginNavigationData({
                          page: "/casino-live/SPB-aviator/SPB",
                          ids: [],
                        });
                      }
                    }}
                  >
                    {/* <SVG_RocketIcon /> */}
                    <AvitorSVG height={20} width={20} />
                    <span className=" font-medium text-start text-text_Ternary ">
                      Aviator
                    </span>
                  </Link>
                </li>
                <li className="border-border_color_primary opacity-70 hover:opacity-100 text-sm cursor-pointer py-4 text-nowrap  whitespace-nowrap autoAnimate font-semibold w-full border-b hover:bg-bg_MenuHoverColor hover:scale-[102%] ">
                  <Link
                    className="flex w-full items-center h-full px-6 justify-start gap-3 text-white"
                    to={userData?.is_demo ? "#" : "/slot-games"}
                    onClick={(e) => {
                      e.preventDefault();
                      if (auth) {
                        if (userData?.is_demo) {
                          toastr.error("", "Please login from your read ID.");
                          return;
                        }
                        navigate("/casino-lobby/slot-games");
                        if (
                          !location.pathname.includes(
                            "/casino-lobby/slot-games"
                          )
                        ) {
                          actions.openSlotCasinoPopUp();
                        }
                      } else {
                        actions.setLoginNew(true);
                        actions.setLoginNavigationData({
                          page: "casino-lobby/slot-games",
                          ids: [],
                        });
                      }
                    }}
                  >
                    {/* <SVG_DiceIcon /> */}
                    <SlotSVG height={20} width={20} />
                    <span className=" font-medium text-start text-text_Ternary ">
                      Slot Games
                    </span>
                  </Link>
                </li>
              </>
            )}
          </ul>
        ) : (
          <>
            {!sideMainMenu && !eventDetailed && !displayNone && (
              <ul className="flex border rounded-lg border-ternary3 bg-bg_Quaternary overflow-x-hidden flex-col w-full ">
                <ul className="flex overflow-x-hidden flex-col w-full no-scrollbar ">
                  {/* <li className="text-sm cursor-pointer py-4 text-nowrap  whitespace-nowrap autoAnimate font-semibold w-full border-b  hover:bg-bg_MenuHoverColor hover:scale-[102%] ">
                    <span className="flex w-full items-center h-full px-6 justify-start gap-3">
                      <SVG_StarIcon />
                      <span className=" font-medium text-start text-text_Ternary ">
                        Favourites
                      </span>
                    </span>
                  </li> */}

                  <li className="text-sm cursor-pointer py-4 text-nowrap  whitespace-nowrap autoAnimate font-semibold w-full border-b  hover:bg-bg_MenuHoverColor hover:scale-[102%] border-ternary3">
                    <span
                      className="flex w-full items-center h-full px-6 justify-start gap-3"
                      onClick={() => {
                        navigate("/");
                        actions.getHomeAllCompetitionError();
                        actions.setIsNavigationID("");
                        actions.setIsNavigationName("");
                      }}
                    >
                      <SVG_HomeIcon fill="var(--icon-color-brand-secondary)" />
                      <span className=" font-medium text-start text-text_Ternary ">
                        Sports
                      </span>
                    </span>
                  </li>
                  <li className="text-sm cursor-pointer py-4 text-nowrap bg-bg_Secondary  whitespace-nowrap autoAnimate font-semibold w-full border-b border-b-secondary hover:scale-[102%] ">
                    <span className="flex w-full items-center h-full px-6 justify-start gap-3">
                      {oneDetailName == "Cricket" ? (
                        <CricketSVG width={20} height={20}/>
                      ) : oneDetailName == "Football" ? (
                        <FootballSVG width={20} height={20}/>
                      ) : oneDetailName === "Tennis" ? (
                        <TennisSVG width={20} height={20}/>
                      ) : navigationName === "Horse Racing" ? (
                        <HorseSVG width={20} height={20}/>
                      ) : navigationName === "Greyhound Racing" ? (
                        <GreySVG width={20} height={20}/>
                      ) : oneDetailName === "Sportsbook" ? (
                        <HomeSVG width={20} height={20}/>
                      ) : null}
                      <span className=" font-medium text-start text-text_Quaternary">
                        {oneDetailName || navigationName}
                      </span>
                    </span>
                  </li>
                  <li className="text-sm cursor-pointer py-4 text-nowrap bg-bg_SideBarDeskBg  whitespace-nowrap autoAnimate font-semibold w-full border-b border-secondary  hover:scale-[102%] ">
                    <span
                      className="flex w-full items-center h-full px-6 justify-start gap-3"
                      onClick={() => {
                        navigate("/");
                        actions.getHomeAllCompetitionError();
                        actions.setIsNavigationID("");
                        actions.setIsNavigationName("");
                      }}
                    >
                      <SVG_PreviousIcon />
                      <span className=" font-medium text-black text-start ">
                        Previous
                      </span>
                    </span>
                  </li>

                  {sportData?.length &&
                  !location.pathname.includes("event-page") &&
                  (navigationName === "Greyhound Racing" ||
                    navigationName === "Horse Racing")
                    ? sportData?.map((item, index) => {
                        return (
                          <li
                            key={item?.market_id}
                            id={item?.market_id}
                            className="text-sm cursor-pointer py-4 text-nowrap opacity-70 hover:opacity-100 whitespace-nowrap autoAnimate font-semibold w-full border-b  hover:bg-bg_MenuHoverColor hover:scale-[102%] border-ternary3"
                          >
                            <span
                              className="flex w-full items-center h-full pl-6 pr-2 justify-between gap-3"
                              onClick={() => {
                                actions.setHrEventId(item.match_id);
                                actions.setHrMarketId(item?.market_id);
                                actions.setHrCountryCode(item.country_code);

                                // onMoreDetails(!eventDetailed);
                                // setTimeout(() => {
                                //   onOpenDetailedMenu(!detailedSideBar);
                                // }, 1000);
                                // actions.setIsAnimatedMenu(true);
                                // actions.setIsMoreDetailed(true);

                                // navigate(
                                //   `/event-page/${item?.sport_id}/${item?.market_id}/${item.match_id}`
                                // );
                              }}
                            >
                              <span className=" font-medium text-start text-text_Ternary  text-wrap">
                                {item.venue}
                                &nbsp; ({item.country_code})
                                <br />
                                <span className=" text-x text-text_color_primary3  text-wrap">
                                  {getTimeDifference(
                                    getZonedTime(
                                      timeSettings?.timeZoneName,
                                      item.market_start_time
                                    )
                                  )}
                                </span>
                              </span>
                              <span className="opacity-50">
                                <SVG_RightIcon />
                              </span>
                            </span>
                          </li>
                        );
                      })
                    : null}

                  {homeMarketEvents.homeAllCompetition?.length &&
                  navigationName !== "Greyhound Racing" &&
                  navigationName !== "Horse Racing"
                    ? homeMarketEvents.homeAllCompetition?.map(
                        (item, index) => {
                          return (
                            <li
                              key={item?.series_id}
                              id={item?.series_id}
                              className="text-sm cursor-pointer py-4 text-nowrap opacity-70 hover:opacity-100 whitespace-nowrap autoAnimate font-semibold w-full border-b  hover:bg-bg_MenuHoverColor hover:scale-[102%] border-ternary3"
                            >
                              <span
                                className="flex w-full items-center h-full pl-6 pr-2 justify-between gap-3"
                                onClick={() => {
                                  actions.setIsNavigationOpen(false);
                                  actions.setRenderIonContent(false);

                                  onMoreDetails(!eventDetailed);
                                  setTimeout(() => {
                                    onOpenDetailedMenu(!detailedSideBar);
                                  }, 1000);
                                  actions.setIsAnimatedMenu(true);
                                  actions.setIsMoreDetailed(true);
                                  // actions.setIsDetailedGroupName(item.name);

                                  // FetchHomeAllEvents(oneDetailItem, item.id);
                                  navigate(
                                    `/competition-detail-page/${item?.series_name}/${oneDetailItem}/${item.series_id}`
                                  );
                                }}
                              >
                                <span className=" font-medium text-start text-text_Ternary  text-wrap">
                                  {item?.series_name}
                                </span>
                                <span className="opacity-50">
                                  <SVG_RightIcon />
                                </span>
                              </span>
                            </li>
                          );
                        }
                      )
                    : null}
                </ul>
              </ul>
            )}

            {eventDetailed && (
              <ul className="flex border rounded-lg border-ternary3 bg-bg_Quaternary overflow-x-hidden flex-col w-full ">
                <ul className="flex overflow-x-hidden flex-col w-full no-scrollbar ">
                  {/* <li className="text-sm cursor-pointer py-4 text-nowrap  whitespace-nowrap autoAnimate font-semibold w-full border-b  hover:bg-bg_MenuHoverColor hover:scale-[102%] ">
                    <span className="flex w-full items-center h-full px-6 justify-start gap-3">
                      <SVG_StarIcon />
                      <span className=" font-medium text-start text-text_Ternary ">
                        Favourites
                      </span>
                    </span>
                  </li> */}
                  <li className="text-sm cursor-pointer py-4 text-nowrap opacity-70 hover:opacity-100 whitespace-nowrap autoAnimate font-semibold w-full border-b  hover:bg-bg_MenuHoverColor hover:scale-[102%] border-ternary3">
                    <span
                      className="flex w-full items-center h-full px-6 justify-start gap-3"
                      onClick={() => {
                        navigate("/");
                        actions.getHomeAllEventsError();
                        actions.setIsEventDetailed(false);
                        actions.setIsDetailedGroupName("");

                        actions.setIsNavigationID("");
                        actions.setIsNavigationName("");
                      }}
                    >
                      <SVG_HomeIcon fill="var(--icon-color-brand-secondary)" />
                      <span className=" font-medium text-start text-text_Ternary ">
                        Sports
                      </span>
                    </span>
                  </li>
                  <li className="text-sm cursor-pointer py-4 text-nowrap bg-bg_Secondary  whitespace-nowrap autoAnimate font-semibold w-full border-b border-b-secondary hover:scale-[102%] ">
                    <span className="flex w-full items-center h-full px-6 justify-start gap-3">
                      {oneDetailName == "Cricket" ? (
                        <SVG_CricketWhiteIcon />
                      ) : oneDetailName == "Football" ? (
                        <SVG_FootballIcon />
                      ) : oneDetailName === "Tennis" ? (
                        <SVG_TennisWhiteIcon />
                      ) : navigationName === "Horse Racing" ? (
                        <SVG_HorseIcon className="horse-icon" />
                      ) : navigationName === "Greyhound Racing" ? (
                        <img
                          src={SVG_GreyhoundIcon}
                          className="greyHound-icon"
                        />
                      ) : null}
                      <span className=" font-medium text-start text-text_Quaternary">
                        {oneDetailName || navigationName}
                      </span>
                    </span>
                  </li>

                  <li className="text-sm cursor-pointer py-4 text-nowrap bg-bg_SideBarDeskBg  whitespace-nowrap autoAnimate font-semibold w-full border-b border-secondary  hover:scale-[102%] ">
                    <span
                      className="flex w-full items-center h-full px-6 justify-start gap-3"
                      onClick={() => {
                        navigate(-1);
                        actions.getHomeAllEventsError();
                        actions.setIsEventDetailed(false);
                        actions.setIsDetailedGroupName("");
                      }}
                    >
                      <SVG_PreviousIcon />
                      <span className=" font-medium text-start text-text_Secondary">
                        Previous
                      </span>
                    </span>
                  </li>

                  {competition && competition?.length > 0 ? (
                    <>
                      <li className="text-sm cursor-pointer py-4 text-nowrap  bg-bg_SideBarDeskBg autoAnimate font-semibold w-full border-b border-secondary  hover:scale-[102%] ">
                        <span
                          className="flex w-full items-center whitespace-pre-wrap h-full px-6 justify-start gap-3"
                          onClick={() => {
                            navigate(-1);
                            actions.getHomeAllEventsError();
                            actions.setIsEventDetailed(false);
                            actions.setIsDetailedGroupName("");
                          }}
                        >
                          <span className=" font-medium text-start text-text_Secondary">
                            {detailedGroupName}
                          </span>
                        </span>
                      </li>

                      {competition.map((item, index) => {
                        return (
                          <li
                            key={item.match_id}
                            className="text-sm cursor-pointer py-4 text-nowrap whitespace-nowrapautoAnimate font-semibold w-full border-b  hover:bg-bg_MenuHoverColor hover:scale-[102%]"
                          >
                            <Link
                              to={`/event-page/${oneDetailItem}/${item.match_id}/${item?.match_name}`}
                            >
                              <span className="flex w-full items-center h-full pl-6 pr-2 justify-between gap-3">
                                <span className=" font-medium text-start text-text_Ternary  text-wrap">
                                  {item.match_name}
                                </span>
                                <span className="opacity-50">
                                  <SVG_RightIcon />
                                </span>
                              </span>
                            </Link>
                          </li>
                        );
                      })}
                    </>
                  ) : null}
                </ul>
              </ul>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default connectLeftSideMenuDesktop()(LeftSideMenuDesktop);
